import React, { memo, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Collapsible } from 'Components'
import ArchiveListings from 'Components/ArchiveListings/ArchiveListingsApiContainer'
import { _ListingPriceHistoryContainer } from './styles'


const ListingPriceHistory = ({ listing, streetAddress, isFetching, isMobileApp, collapsibleIdSuffix }) => {
  const { title, name } = listing || {}

  const [showArchiveListings, setShowArchiveListings] = useState(false)

  useEffect(() => {
    if(listing && (listing.building?.id || listing?.address_id) && !isFetching && !showArchiveListings) {
      setShowArchiveListings(true)
    }
  }, [listing, isFetching, showArchiveListings])

  return (
    <_ListingPriceHistoryContainer>
      <Collapsible
        inputId={`PriceHistory-${collapsibleIdSuffix}`}
        title={'Price History'}
        gaActionTitle={'Listing Price History'}
        seoText={
          `Discover the price history for ${title || name || ''}`
        }
        defaultShowState={!isMobileApp}
        isCollapsible={false}
        showSeparatorLine={false}
        openCollapseTargetId={`PriceHistory-${collapsibleIdSuffix}`}
      >
        <div key={`listing-price-history-${listing && listing.id}`}>

          {
            showArchiveListings && listing ?
              <ArchiveListings
                isListing
                showLinkToHistoryPage
                buildingId={listing.building?.id}
                addressId={listing.address_id}
                suiteNumber={listing.unit_name}
                propertyClass={listing.property_class}
                priceHistoryAtText={streetAddress}
                offer={'All'}
                pageFrom={'listing'}
              />
              : ''
          }
        </div>
      </Collapsible>
    </_ListingPriceHistoryContainer>
  )
}


ListingPriceHistory.propTypes = {
  listing: PropTypes.shape({
    id: PropTypes.number,
    building: PropTypes.shape({
      id: PropTypes.number,
    }),
    offer: PropTypes.string,
    address_id: PropTypes.number,
    unit_name: PropTypes.string,
    property_class: PropTypes.string,
  }),
  streetAddress: PropTypes.string,
  isFetching: PropTypes.bool,
  isMobileApp: PropTypes.bool,
  collapsibleIdSuffix: PropTypes.string,
}

export default memo(ListingPriceHistory)
